import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map, retry, throwError } from 'rxjs';
import { AppService } from './app.service';
import { environment } from '../../../environments/environment';

/** Extra per-request options. Currently only custom headers are supported. */
export interface ApiRequestOptions {
  headers?: HttpHeaders | Record<string, string>;
}


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  serverUrl = environment.serverUrl;

  constructor(
    private http: HttpClient,
    private _app: AppService
  ) { }

  getData(endPoint: string): any {
    const vm = this;
    setTimeout(function () { vm._app.spinnerData = true; }, 0);
    return vm.http.get(vm.serverUrl + endPoint).pipe(
      retry(0),
      map(res => {
        setTimeout(function () { vm._app.spinnerData = false; }, 0);
        return res;
      }),
      catchError(err => {
        return vm.handleError(err, vm);
      }));
  }

  /**
   * `options.headers` is how callers attach an `idempotency-key` to the money-path
   * endpoints (`/admin/credit-balance`, `/admin/update-disputes`), which the backend
   * rejects with a 400 when the header is absent. See `newIdempotencyKey()`.
   */
  postData(endPoint: string, data: any, options?: ApiRequestOptions): any {
    const vm = this;
    setTimeout(function () { vm._app.spinnerData = true; }, 0);
    return vm.http.post(vm.serverUrl + endPoint, data, vm.buildHttpOptions(options)).pipe(
      retry(0),
      map(res => {
        setTimeout(function () { vm._app.spinnerData = false; }, 0);
        return res;
      }),
      catchError(err => {
        return vm.handleError(err, vm);
      }));
  }

  /** Normalises `ApiRequestOptions` into what HttpClient expects. */
  private buildHttpOptions(options?: ApiRequestOptions): { headers?: HttpHeaders } {
    if (!options?.headers) {
      return {};
    }
    return {
      headers:
        options.headers instanceof HttpHeaders
          ? options.headers
          : new HttpHeaders(options.headers),
    };
  }

  putData(endPoint: string, data: any): any {
    const vm = this;
    setTimeout(function () { vm._app.spinnerData = true; }, 0);
    return vm.http.put(vm.serverUrl + endPoint, data).pipe(
      retry(0),
      map(res => {
        setTimeout(function () { vm._app.spinnerData = false; }, 0);
        return res;
      }),
      catchError(err => {
        return vm.handleError(err, vm);
      }));
  }

  deleteData(endPoint: string): any {
    const vm = this;
    setTimeout(function () { vm._app.spinnerData = true; }, 0);
    return vm.http.delete(vm.serverUrl + endPoint).pipe(
      retry(0),
      map(res => {
        setTimeout(function () { vm._app.spinnerData = false; }, 0);
        return res;
      }),
      catchError(err => {
        return vm.handleError(err, vm);
      }));
  }

  handleError(error: any, vm: any): any {
    if (!environment.production) {
      console.log('API Service Error:', error);
    }
    let errorMessage = 'Unknown error!';
    setTimeout(function () { vm._app.spinnerData = false; }, 0);
    
    // Handle different error formats
    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error && error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else if (error && typeof error.error === 'string') {
      errorMessage = error.error;
    } else if (error && error.error && error.error.message) {
      errorMessage = error.error.message;
    } else if (error && error.message) {
      errorMessage = error.message;
    } else {
      try {
        errorMessage = JSON.stringify(error);
      } catch (e) {
        errorMessage = 'An unknown error occurred';
      }
    }
    
    return throwError(() => errorMessage);
  }
}